import styled from 'styled-components'

export const StyledMagnifyButton = styled.div<{
  action?: 'open' | 'close'
}>`
  width: 2.8rem;
  height: 2.8rem;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  color: #ffffff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  position: ${(props) => (props.action === 'close' ? 'fixed' : 'absolute')};
  top: 1.8rem;
  right: 1.2rem;
  z-index: ${(props) => (props.action === 'close' ? '10000' : '10')};
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  svg {
    width: 16px;
    height: 16px;
  }

  @media screen and (min-width: 768px) {
    width: 32px;
    height: 32px;

    &:hover {
      transform: scale(1.2);
    }
  }

  @media screen and (min-width: 992px) {
    top: 4.2rem;
    right: 4.2rem;
  }
`
